import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LearningContentState {
  type?: string;
  category?: string;
  isNew?: boolean;
  videoUrl?: string;
  fullHtml?: string;
  title?: string;
  summarry?: string;
  casePlanMilestoneMappingId?: string;
  activityCompletionStatus?: string;
  patientProfileId?: number;
  lang?: string;
  activityPoints?: number;
  audioUrl?: string;
  thumbnail?: string;
  publisherName?: string;
  publishedDate?: string;
  length?: number;
  educationalContentIdentifier?: string;
  educationalContentSourceId?: number;
  navigationInfo?: {
    isViewLearningContentEnabled: boolean;
    arrivedFrom: string;
  }
}

const initialState: LearningContentState = {};

const learningContentSlice = createSlice({
  name: "learningContent",
  initialState,
  reducers: {
    setLearningContent: (
      state,
      action: PayloadAction<LearningContentState>
    ) => {
      return { ...state, ...action.payload };
    },
    resetLearningContent: () => initialState,
  },
});

export const { setLearningContent, resetLearningContent } =
  learningContentSlice.actions;

export default learningContentSlice.reducer;
